module.exports = __webpack_public_path__ + "img/score30.f76fcb38.png";